import script from "./WebContact.vue?vue&type=script&setup=true&lang=js"
export * from "./WebContact.vue?vue&type=script&setup=true&lang=js"

import "./WebContact.vue?vue&type=style&index=0&id=fc3bdcf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc3bdcf2"]])

export default __exports__